import { render } from "./EquationEditor.vue?vue&type=template&id=4acf28d0"
import script from "./EquationEditor.vue?vue&type=script&lang=js"
export * from "./EquationEditor.vue?vue&type=script&lang=js"

import "./EquationEditor.vue?vue&type=style&index=0&id=4acf28d0&lang=scss"

import exportComponent from "/app/tmp/origina/V3/v2026.22.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__